const carrierTypes = {
	amazon: 'Amazon Shipping',
	ups: 'UPS',
	fedex: 'FedEx',
	usps: 'USPS',
	passport: 'Passport',
	ltl: 'LTL',
	ontrac: 'OnTrac',
};

// ShipStation quotes rates from the carriers connected to its own account rather than ours, and currently
// returns FedEx, UPS and USPS only, so a ShipStation channel can never ship with another carrier type.
const shipStationCarrierTypes = [carrierTypes.fedex, carrierTypes.ups, carrierTypes.usps];

export { carrierTypes, shipStationCarrierTypes };
